import React, { useEffect, useState } from "react";
import { Header, Segment, Pagination, Dropdown } from "semantic-ui-react";
import { connect } from "react-redux";
import moment from "moment";

import TitleBar from "../titleBar/titleBar";
import AgGridTable from "../agGridComponent/agGridTable";
import LoadingPlaceholder from "../placeholder/loadingPlaceholder";

// import SalesOrderActionButton from "./salesOrderActionButton";
import PdfActionButton from "./pdfActionButton";
import Axios from "axios";
import APP_CONSTANT from "../../config/constants";

import {
  deleteSalesOrder,
  getSalesOrder,
  getGeneratedPdf,
} from "../../redux/actions/salesOrderActions";
import SalesOrderFilterModal from "./creditNoteFilterModal";
import {
  dateFormats,
  messages,
  salesOrderPaginationConfig,
} from "../../utils/constant";
import { headers, titles } from "./creditNote.constants";

import {
  GET_SALESORDER_REQUEST,
  GET_SALESORDER_SUCCESS,
  GET_SALESORDER_FAIL,
} from "../../redux/types/salesOrderTypes";
import CreditNoteActionButton from "./creditNoteActionButton";
import CreditNoteFilterModal from "./creditNoteFilterModal";
import { deleteCreditNote, getCreditNote } from "./creditNoteCRUD";
import cogoToast from "cogo-toast";
import { Transporter } from "../utils/constants";
import IrnCodeRender from "../customerInvoice/1568/irnCodeRender";
import IntegratedReferenceNumber from "../customerInvoice/1568/integratedReferenceNumber";

function CreditNoteTable(props) {
  const {
    salesOrderData,
    salesOrderLoading,
    deleteSalesOrder,
    deleteSalesOrderIsLoading,
    getGeneratedPdf,
    getSalesOrder,
    // getSalesOrderFilter,
    paginationData,
  } = props;
  const [searchValue, setSearchValue] = useState("");
  const [ClientCode, setClientCode] = useState(null);
  const [BranchCode, setBranchCode] = useState(null);
  const [VehicleCode, setVehicleCode] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState();
  const [itemCount, setItemCount] = useState(10);
  const [itemsPerPage, setItemsPerPage] = useState(
    salesOrderPaginationConfig[0].pageSize
  );
  const [selectedRows, setSelectedRows] = useState([]);
  const [loadingData, setLoadingData] = useState(false);
  const [showstatusloader, setShowstatusloader] = useState(false);
  const [selectUser, setSelectUser] = useState(false);
  const [defaultOptions, setDefaultOptions] = useState([]);
  const [rowData, setRowData] = useState([]);
  const [filterOptions, setFilterOptions] = useState({});
  const [creditNoteData, setCreditNoteData] = useState([])
  const [creditNotePagination, setCreditNotePagination] = useState([])
  const [creditNoteLoading, setCreditNoteLoading] = useState(false)
  console.log(creditNoteData,'creditNoteData')

  const [showFilterModal, setShowFilterModal] = useState(false);
  const [filterData, setFilterData] = useState({
    searchTerm: "",
    clientCode: "",
    branchCode: "",
  });
  const [branchFilterOptions, setBranchFilterOptions] = useState([]);
  const [branchFilterValue, setBranchFilterValue] = useState({});

  let perPageItems = salesOrderPaginationConfig.map((item, index) => {
    return { key: index + 1, text: item.label, value: `${item.pageSize}` };
  });



  useEffect(() => {
    setCreditNoteLoading(true)
    setCurrentPage(1);
    getCreditNote(currentPage).then((res) => {setCreditNoteData(res.data);setCreditNotePagination(res.pagination);setCreditNoteLoading(false)}).catch((err) => {setCreditNoteLoading(false)})
  }, []);



  const handlePaginationChange = (e, { activePage }) => {
    setCreditNoteLoading(true)
    setCurrentPage(activePage);
    setLoadingData(true);
    setShowstatusloader(true);
    setRowData([]);
    getCreditNote(currentPage).then((res) => {setCreditNoteData(res.data);setCreditNotePagination(res.pagination);setCreditNoteLoading(false)}).catch((err) => {setCreditNoteLoading(false)})
  };



  if (creditNoteLoading) {
    return (
      <React.Fragment>
        <TitleBar
          title={titles.creditNote || "Credit Note"}
          LinkName="add-salesorder"
        />
        <LoadingPlaceholder />
      </React.Fragment>
    );
  } else if (creditNoteData && creditNoteData.length === 0) {
    return (
      <React.Fragment>
        <TitleBar
          title={titles.creditNote || "Credit Note"}
          LinkName="add-salesorder"
        />
        <Segment className="m-2">
          <center>
            <Header>{messages.NO_RECORDS_FOUND}</Header>
          </center>
        </Segment>
      </React.Fragment>
    );
  } else {
    let columnDefs = [
      {
        headerName: headers.creditNoteNumber || "CreditNote No.",
        field: "creditNoteNo",
        tooltipField: "creditNoteNo",
        enableRowGroup: true,
        enablePivot: true,
        filter: true,
      },
      {
        headerName: headers.creditNoteDate || "CreditNote Date",
        field: "transaction_date",
        tooltipField: "transaction_date",
        enableRowGroup: true,
        enablePivot: true,
        filter: true,
      },
      {
        headerName: headers.creditAmount|| "Credit Amount (Rs)",
        field: "credit_amount",
        tooltipField: "credit_amount",
        enableRowGroup: true,
        enablePivot: true,
        filter: true,
      },
      { 
        headerName: headers.irn_code || 'IRN Code',
        field: 'irnCode',
        cellRenderer: 'IrnCodeRender',
        enableRowGroup: true,
        enablePivot: true, 
        filter: true, 
        hide: !Transporter, 
      },
      { 
        headerName: headers.integrated_ref_no || 'Integrated Reference Number',
        field: 'integratedReferenceNo',
        cellRenderer: 'integratedReferenceNo',
        enableRowGroup: true,
        enablePivot: true, 
        filter: true, 
        hide: !Transporter, 
      },
      {
        headerName: headers.approved_on || "Approved On",
        field: "approved_thirdparty_api_date",
        //tooltipField: "approved_thirdparty_api_date",
        enableRowGroup: true,
        enablePivot: true,
        filter: true,
        hide: !Transporter,
      },
      {
        headerName: headers.branchName || "Branch",
        field: "branch_name",
        tooltipField: "branch_name",
        enableRowGroup: true,
        enablePivot: true,
        filter: true,
      },
      {
        headerName: headers.remarks || "Remarks",
        field: "remarks",
        tooltipField: "remarks",
        enableRowGroup: true,
        enablePivot: true,
        filter: true,
      },
      {
        headerName: headers.createdOn || "Created On",
        field: "created_at",
        tooltipField: "created_at",
        enableRowGroup: true,
        enablePivot: true,
        filter: true,
      },
      {
        headerName: headers.createdBy || "Created By",
        field: "createdBy",
        tooltipField: "createdBy",
        enableRowGroup: true,
        enablePivot: true,
        filter: true,
      },
      // {
      //   headerName: headers.modifiedOn || "Modified On",
      //   field: "modifiedOn",
      //   tooltipField: "modifiedOn",
      //   enableRowGroup: true,
      //   enablePivot: true,
      //   filter: true,
      // },
      // {
      //   headerName: headers.modifiedBy || "Modified By",
      //   field: "modifiedBy",
      //   tooltipField: "modifiedBy",
      //   enableRowGroup: true,
      //   enablePivot: true,
      //   filter: true,
      // },
      // { headerName: 'PDF', field: 'pdf', cellRenderer: 'pdfRenderer',  width: 100, suppressToolPanel: true },
      {
        headerName: headers.edit || "Delete",
        field: "edit",
        cellRenderer: "actionRenderer",
        width: 280,
        suppressToolPanel: true,
        pinned: "right",
      },
    ];

    let frameworkComponents = {
      actionRenderer: CreditNoteActionButton,
      pdfRenderer: PdfActionButton,
      IrnCodeRender : IrnCodeRender,
      integratedReferenceNo : IntegratedReferenceNumber
    };

    let rowData = [];
    creditNoteData &&
    creditNoteData.forEach((object, index) => {
        let creditNote = {};
        creditNote.creditNoteNo = object.credit_note_no
        creditNote.transaction_date = object.transaction_date
        creditNote.credit_amount = object.credit_amount
        creditNote.branch_name = object.branch_name
        creditNote.remarks = object.remarks
        creditNote.created_at = object.created_at
        creditNote.createdBy = object.created_by_name
        creditNote.deleteCreditNote = deleteCreditNote
        creditNote.credit_note_id = object.credit_note_id
        creditNote.is_used = object.is_used
        creditNote.irnCode = object.einvoice_irn_code
        creditNote.eInvIntegratedReferenceNumberErrorContent = object.einvoice_details && object.einvoice_details.length && object.einvoice_details[0]['request_get']
        
        let integratedReferenctObj = object.get_integrated_reference && object.get_integrated_reference.length && object.get_integrated_reference[0]
        creditNote.integratedReferenceNumberErrorContent = integratedReferenctObj && integratedReferenctObj.request_get
        creditNote.integratedReferenceNumber = integratedReferenctObj && (creditNote.integratedReferenceNumberErrorContent ? "Error" :integratedReferenctObj.integrated_reference_no)
        creditNote.reloadIntegratedRefNo = true

        creditNote.approved_thirdparty_api_date = object.approved_thirdparty_api_date
       
        rowData[index] = creditNote;
      });

    const handleFilterModelClose = () => {
      setShowFilterModal(false);
    };

    const handleFilterModelOpen = () => {
      setShowFilterModal(true);
    };

    const handleFilter = (values) => {
      getSalesOrder(
        itemsPerPage,
        searchValue,
        1,
        null,
        values.clientCode,
        values.branchCode
      );
    };

    const newPopup = () => {
      props.history.push("/add-salesorder");
    };

    const handleSalesFilterModelOpen = (values) => {
      if (values?.searchString && values?.searchString != "") {
        setSearchValue(values?.searchString);
      }
      getSalesOrder(
        itemsPerPage,
        searchValue,
        currentPage,
        null,
        filterData.clientCode,
        filterData.branchCode
      );
    };

    const filterSales = (payload) => {
      setSearchValue(payload?.search_value);
      setClientCode(payload?.client_code?.toString());
      setBranchCode(payload?.branch_code);
      setVehicleCode(payload?.vehicle_id?.toString());
      getSalesOrder(
        itemsPerPage,
        payload?.search_value,
        1,
        null,
        payload?.client_code?.toString(),
        payload?.branch_code,
        '',
        null,
        payload?.vehicle_id?.toString()

      );
    };

    return (
      <React.Fragment>
        {showFilterModal && (
          <CreditNoteFilterModal
            setDefaultOptions={setDefaultOptions}
            defaultOptions={defaultOptions}
            selectCustomerName={setSelectUser}
            selectUser={selectUser}
            open={showFilterModal}
            setOpen={setShowFilterModal}
            handleClose={handleFilterModelClose}
            setData={setFilterData}
            data={filterData}
            selectedBranch={branchFilterValue}
            setSelectedBranch={setBranchFilterValue}
            branchOptions={branchFilterOptions}
            setBranchOptions={setBranchFilterOptions}
          />
        )}
        <AgGridTable
          customizedSearch={false}
          columnDefs={columnDefs}
          pagination={false}
          rowData={rowData}
          searchValue={searchValue}
          ClientCode={ClientCode}
          BranchCode={BranchCode}
          VehicleCode={VehicleCode}
          link="/add-salesorder"
          baseURL={props}
          newPopup={newPopup}
          hiddenNewPopupBtn={true}
          hiddenImportPopupBtn={true}
          extraComponents={frameworkComponents}
          titleBarTitle={titles.creditNote || "Credit Note"}
          hiddenFilterButton={true}
          handleFilterOpen={handleFilterModelOpen}
          getFilterSalesOrder={handleSalesFilterModelOpen}
          setFilterValues={filterSales}
        />
        <div className="life-cycle w3-white ui pagination menu">
          <Pagination
            defaultActivePage={currentPage || creditNotePagination.currentPage}
            firstItem={null}
            lastItem={null}
            onPageChange={handlePaginationChange}
            pointing
            secondary
            totalPages={creditNotePagination.totalPages}
          />
        </div>
      </React.Fragment>
    );
  }
}

const mapStatetoProps = (state) => ({
  salesOrderData: state.getSalesOrderData.salesOrder.data,
  paginationData: state.getSalesOrderData.salesOrder.pagination,
  salesOrderLoading: state.getSalesOrderData.isLoading,
  deleteSalesOrderIsLoading: state.deleteSalesOrderData.isLoading,
});

export default connect(mapStatetoProps, {
  getSalesOrder,
  deleteSalesOrder,
  getGeneratedPdf,
})(CreditNoteTable);
